export default {
  // Componente visual - sin cadenas de texto traducibles
}
